//
//
//
//
//

import ManageApply from '@/listing-app/mixins/ManageApply'
export default {
  name: "NextGen",
	mixins: [ManageApply],
  methods: {
    set_outline() {
      document.body.addEventListener("mousedown", function() {
        document.body.classList.add("using-mouse")
      })
      document.body.addEventListener("keydown", function() {
        document.body.classList.remove("using-mouse")
      })
    }
  },
  created() {
    this.set_outline()
	},
	mounted() {
		this.init_apply()
	}
};
